import React, { useCallback, useMemo, useContext, useState } from "react";
import { connect } from "dva";
import { useTranslation } from "react-i18next";
import ComNoticeCard from "@/baseComponents/ComNoticeCard";
import { FocusSDK } from "@/utils";
import { changeEgovUrl } from "@/utils/tools";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { message as toast, Modal, Input } from "antd";
import { updateApproveBackLog } from "@/api/chat";
import { handleLinkClick } from "./utils";
import { useHistory } from "react-router-dom";

const UnifiedToDoListCard = ({ message }: { message: any }) => {
  const { title, extend, sender } = message;
  const content = extend.fields;
  const avatarSrc = sender.avatar;
  const [t] = useTranslation("chat");
  const { authInfo, appRuntimeEnv, service } = React.useContext<GlobalContextConfig>(GlobalContext);
  let history = useHistory();
  const [rejectReason, setRejectReason] = useState("");
  const [showRejectModal, setShowRejectModal] = useState(false);

  const handleClickDetail = () => {
    const isPrivateNet = FocusSDK.isPrivateNet();
    const url = isPrivateNet ? extend.egovUrl : extend.url;
    if (!url) {
      toast.warn("该应用不支持在当前网络环境下打开");
      return;
    }
    if (url) {
      handleLinkClick(url || "", message, authInfo, appRuntimeEnv, history, service);
    }
  };

  const approvedAction = useCallback(async () => {
    const param = {
      approveResult: 1,
      itemIds: [message.infox.itemId]
    };
    
    const [result, error] = await updateApproveBackLog(param);
    if (error) {
      toast.error(error);
      return;
    }
  }, [message]);

  const rejectedAction = useCallback(async () => {
    setShowRejectModal(true);
  }, []);

  const handleRejectCancel = useCallback(() => {
    setShowRejectModal(false);
    setRejectReason("");
  }, []);

  const handleRejectConfirm = useCallback(async () => {
    if (!rejectReason.trim()) {
      toast.error("请填写驳回原因");
      return;
    }
    const param = {
      approveResult: 0,
      itemIds: [message.infox.itemId],
      rejectReason: rejectReason.trim()
    };
    const [result, error] = await updateApproveBackLog(param);
    if (error) {
      toast.error(error);
      return;
    }
    setRejectReason("");
    setShowRejectModal(false);
    toast.success("操作成功");
  }, [message, rejectReason, t]);

  const handleClick = useCallback(
    (btn) => {
      // 驳回：backlogItemCheckFail，
      // 通过：backlogItemCheckPass，
      // 已通过：backlogItemPass，
      // 已驳回：backlogItemFail
      switch (btn.action) {
        case "backlogItemCheckPass":
          return approvedAction();
        case "backlogItemCheckFail":
          return rejectedAction();
      }
    },
    [approvedAction, rejectedAction]
  );

  return (
    <>
      <ComNoticeCard
        message={message}
        avatarSrc={changeEgovUrl(avatarSrc)}
        type={extend.applicationName}
        contentList={content}
        title={title}
        handleDetail={extend.url || extend.egovUrl ? () => handleClickDetail() : null}
        loadButtonsFn={
          extend?.btns?.length > 0
            ? () => {
                return (
                  <div className="button_items">
                    {extend.btns.map((btn: any, idx: number) => {
                      return (
                        <button
                          key={idx}
                          onClick={() => handleClick(btn)}
                          disabled={btn.status === "0" ? true : false}
                          style={{
                            color: btn.status === "0" ? "#8F959EFF" : "",
                            cursor: btn.status === "0" ? "default" : "pointer"
                          }}
                        >
                          {btn.name}
                        </button>
                      );
                    })}
                  </div>
                );
              }
            : extend.url
            ? () => (
                <div className="button_item" onClick={() => handleClickDetail()}>
                  {t("click-to-view")}
                </div>
              )
            : null
        }
      />

      <Modal
        visible={showRejectModal}
        title="填写驳回原因"
        onOk={handleRejectConfirm}
        onCancel={handleRejectCancel}
        okText="确定"
        cancelText="取消"
        maskClosable={true}
        destroyOnClose
      >
        <Input.TextArea
          placeholder="请填写驳回原因"
          value={rejectReason}
          onChange={(e) => setRejectReason(e.target.value)}
          rows={4}
        />
      </Modal>
    </>
  );
};

function mapStateToProps() {
  return {};
}

function mapDispatchToProps() {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(UnifiedToDoListCard);
